const runtime = (window as any).__RUNTIME_CONFIG__ || {};
export const API_URL =
  runtime.API_URL || process.env.REACT_APP_API_URL || "http://localhost:3000";